<template>
  <v-row>
    <v-col cols="3" class="align-vertical no-padding">
      <v-checkbox
        v-model="dmsEnableState"
        item-text="label"
        :label="label"
        @change="emitNewVals($event, 'state')"
      />
    </v-col>
    <v-col v-if="displaySpeedThreshold" cols="3" class="align-vertical no-padding">
      <v-select
        v-model="speedThreshold[selectedUnits]"
        :items="speedThresholdList"
        item-text="label"
        item-value="xml"
        @change="emitNewVals(speedThreshold[selectedUnits], 'speed')"
      />
    </v-col>
    <v-col v-if="displayDuration" cols="3" class="align-vertical no-padding">
      <v-select
        v-model="duration"
        :items="durationOptions"
        item-text="label"
        item-value="xml"
        @change="emitNewVals(duration, 'duration')"
      />
    </v-col>
    <v-col v-if="rateLimiting" cols="3" class="align-vertical no-padding">
      <v-select
        v-model="rateLimit"
        :items="rateLimitBand"
        item-text="label"
        item-value="xml"
        @change="emitNewVals(rateLimit, 'rateLimit')"
      />
    </v-col>
    <v-col v-if="angleSupport" cols="2" class="align-vertical no-padding">
      <v-select
        v-model="angle"
        :items="angleOptions"
        item-text="label"
        item-value="xml"
        @change="emitNewVals(angle, 'angle')"
      />
    </v-col>
  </v-row>
</template>

<script>

import { Logger } from "aws-amplify";
const logger = new Logger("DriverMonitoringSystemSettings");

export default {
  name: 'DriverMonitoringSystemSettings',
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    subType: {
      type: String,
      required: false,
      default: ''
    },
    config: {
      type: Array,
      required: true
    },
    displaySpeedThreshold: {
      type: Boolean,
      required: false,
      default: true
    },
    displayDuration: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedUnits: {
      required: false,
      type: String,
      default: 'kph'
    },
    rateLimiting: {
      required: false,
      type: Boolean,
      default: false
    },
    angleSupport: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dmsEnableState: false,
      speedThreshold: {
        kph: 0,
        mph: 0
      },
      thresholdOptions: {
        kph: [
          {
            xml: '0',
            label: '0'
          },
          {
            xml: '10',
            label: '10'
          },
          {
            xml: '20',
            label: '20'
          },
          {
            xml: '30',
            label: '30'
          },
          {
            xml: '40',
            label: '40'
          },
          {
            xml: '50',
            label: '50'
          },
          {
            xml: '60',
            label: '60'
          }
        ],
        mph: [
          {
            xml: '0',
            label: '0'
          },
          {
            xml: '16',
            label: '10'
          },
          {
            xml: '24',
            label: '15'
          },
          {
            xml: '32',
            label: '20'
          },
          {
            xml: '40',
            label: '25'
          },
          {
            xml: '48',
            label: '30'
          },
          {
            xml: '56',
            label: '35'
          }
        ]
      },
      durationOptions: [
        {
          xml: 2,
          label: 2
        },
        {
          xml: 3,
          label: 3
        },
        {
          xml: 4,
          label: 4
        },
        {
          xml: 5,
          label: 5
        },
        {
          xml: 6,
          label: 6
        },
        {
          xml: 7,
          label: 7
        },
        {
          xml: 8,
          label: 8
        }
      ],
      angleOptions: [
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55,
        60,
        65,
        70,
        75,
        80,
        85,
        90
      ],
      rateLimit: 0,
      test: [1,2,3,4,5,6,7,8],
      duration: 0,
      angle: 0,
      speedThresholdIndex: 0
    }
  },
  computed: {
    speedThresholdList() {
      return this.thresholdOptions[this.selectedUnits];
    },
    rateLimitBand() {
      let band = []

      for (let i = 1; i < 31; i++) {
        band.push(i)
      }

      return band
    }
  },
  watch: {
    selectedUnits() {
      this.mapGeneralSettings(true);
    },
    speedThreshold: {
      deep: true,
      handler() {
        this.setSpeedThresholdIndex()
      }
    }
  },
  mounted() {
    this.mapGeneralSettings();
    this.setSpeedThresholdIndex();
  },
  methods: {
    setSpeedThresholdIndex() {
      logger.info('changed setSpeedThresholdIndex', this.speedThreshold[this.selectedUnits])
      this.speedThresholdIndex = this.thresholdOptions[this.selectedUnits].findIndex(item => parseInt(item.xml) == parseInt(this.speedThreshold[this.selectedUnits]));
    },
    mapGeneralSettings(unitChange = false) {
      let alert = this.config.find(item => {
        if(item.hasOwnProperty('event')) {
          return this.subType == '' ? item.event.find(event => event.type[0] == this.type) : item.event.find(event => event.type[0] == this.subType)
        }
        else {
          return item.type[0] === this.type;
        }
        
      });

      if(alert && alert.hasOwnProperty('event')) {
        
        if(this.subType == '') {
          alert = alert.event.find(item => item.type[0] == this.type)
        }
        else {
          alert = alert.event.find(item => item.type[0] == this.subType)
        }
        logger.info('alert debug ', alert)
        if(alert.hasOwnProperty('angle')) {
          this.angle = parseInt(alert.angle[0]);
        }
      }
      if(!alert) return;
      this.dmsEnableState = JSON.parse(alert.enabled[0]);

      if(alert.hasOwnProperty('duration')) {
        this.duration = parseInt(alert.duration[0]);
      }
      
      // I have to check for the rateLimit attribute as not all devices will have it
      if(alert.hasOwnProperty('rateLimit')) {
        this.rateLimit = parseInt(alert.rateLimit[0]);
      }

      if (this.displaySpeedThreshold) {
        if (!this.selectedUnits) return;
        const validSpeed = this.thresholdOptions[this.selectedUnits].find(item => parseInt(item.xml) == parseInt(alert.speed[0]));
        
        if(validSpeed) {
          logger.info('validSpeed ', validSpeed, alert.speed[0])
          this.speedThreshold[this.selectedUnits] = alert.speed[0];
        }
        else {
          if(this.selectedUnits == 'kph') {
            this.speedThreshold[this.selectedUnits] = '20';
          }
          else if (this.selectedUnits == 'mph') {
            this.speedThreshold[this.selectedUnits] = '32';
          }
        }
        if(unitChange) {
          logger.info('change units')
          this.speedThreshold[this.selectedUnits] = this.thresholdOptions[this.selectedUnits][this.speedThresholdIndex].xml
          this.emitNewVals(this.speedThreshold[this.selectedUnits], 'speed')
        }
      }
    },
    eventMap(key, type) {
      const map = {
        state: {
          'phone': 'dmsPhoneAlerts',
          'smoking': 'dmsSmokingAlerts',
          'fatigue': 'dmsFatigueAlerts',
          'distraction': 'dmsDistractionAlerts',
          'occlusion': 'dmsOcclusionAlerts',
          'lookLeft': 'dmsLookLeft',
          'lookRight': 'dmsLookRight',
          'lookDown': 'dmsLookDown',
          'eyesClosed': 'dmsEyesClosed',
          'yawn': 'dmsYawn'
        },
        speed: {
          'phone': 'dmsPhoneSpeed',
          'smoking': 'dmsSmokingSpeed',
          'fatigue': 'dmsFatigueSpeed',
          'distraction': 'dmsDistractionSpeed',
          'occlusion': 'dmsOcclusionAlerts',
          'lookLeft': 'dmsLookLeftSpeed',
          'lookRight': 'dmsLookRightSpeed',
          'lookDown': 'dmsLookDownSpeed',
          'eyesClosed': 'dmsEyesClosedSpeed',
          'yawn': 'dmsYawnSpeed'
        },
        rateLimit: {
          'phone': 'dmsPhoneRateLimit',
          'smoking': 'dmsSmokingRateLimit',
          'fatigue': 'dmsFatigueRateLimit',
          'distraction': 'dmsDistractionRateLimit',
          'occlusion': 'dmsOcclusionRateLimit',
          'eyesClosed': 'dmsEyesClosedRateLimit',
          'yawn': 'dmsYawnRateLimit'
        },
        duration: {
          'phone': 'dmsPhoneDuration',
          'smoking': 'dmsSmokingDuration',
          'eyesClosed': 'dmsEyesClosedDuration',
          'yawn': 'dmsYawnDuration',
          'lookLeft': 'dmsLookLeftDuration',
          'lookRight': 'dmsLookRightDuration',
          'lookDown': 'dmsLookDownDuration',
        },
        angle: {
          'lookLeft': 'dmsLookLeftAngle',
          'lookRight': 'dmsLookRightAngle',
          'lookDown': 'dmsLookDownAngle',
        }
      }


      return map[type][key];
    },
    emitNewVals(data, valType) {
      const alertType = this.subType == '' ? this.type : this.subType
      // Used for alerts that have a sub type (yawning, look left etc...) to match up with the parent alert type (distract, fatigue etc...)
      const parent = this.subType == '' ? false : this.type
      logger.info('hmmmm', this.subType, this.type, parent)
      this.$emit('dmsAlertsUpdated', data, this.eventMap(alertType, valType), alertType, this.label, parent);
    },
    mapSelectedUnits(units) {
      if (!units) return;

      const map = {
        'kph': 'KPH',
        'mph': 'MPH'
      }

      if (Object.hasOwn(map, units)) {
        return map[units];
      }
      else {
        return 'N/A';
      }

    }
  }
}
</script>

<style lang="scss" scoped>
  .speed-units {
    padding-left: 1em;
  }
</style>